export default __webpack_public_path__ + "static/media/6cd06f03e018e126004280382024609a.gif";